import { MuiRhfCheckbox } from '@edge/spark/feature-mui-rhf-inputs'
import { Stack, Typography } from '@mui/material'
import React from 'react'
import { checkRoles, useRoles, FeatureFlagRoles, useIsGlobalAdmin } from '@edge/spark/io-roles'

const defaultWorkflows = [
    {
        ordinal: '1',
        label1: 'Edit Sale Info',
        label2: 'Prepare vehicles for sale by editing floor, lights, and announcements',
        requiredRoles: [`${FeatureFlagRoles.EDIT_VEHICLE_SALE_CONDITIONS}`],
        allowEdgeAdmin: true,
    },
]

export const WorkflowsView: React.VFC = () => {
    const roles = useRoles()
    const edgeAdmin = useIsGlobalAdmin()

    return (
        <Stack>
            <Typography variant="body2" sx={{ mb: 1 }}>
                Select workflows to add to the card details page:
            </Typography>
            <Stack>
                {defaultWorkflows.map((workflow, index) => {
                    // TODO Move checkAuth to workflow lib function */
                    const authorizedAsAdmin = edgeAdmin && workflow.allowEdgeAdmin

                    if (workflow.requiredRoles && !authorizedAsAdmin) {
                        const foundRole = checkRoles(roles, workflow.requiredRoles)
                        if (!foundRole) {
                            return null
                        }
                    }

                    const name = `workflows.${index}`

                    return (
                        <MuiRhfCheckbox
                            key={name}
                            sx={{
                                alignItems: 'flex-start',
                                '& .MuiCheckbox-root': {
                                    pt: 0,
                                },
                            }}
                            label={
                                <Stack>
                                    <Typography sx={{ fontWeight: 500, color: 'text.primary' }}>
                                        {workflow.label1}
                                    </Typography>
                                    <Typography variant="subtitle1">{workflow.label2}</Typography>
                                </Stack>
                            }
                            name={name}
                        />
                    )
                })}
            </Stack>
        </Stack>
    )
}

export default WorkflowsView
